/** @type {import('tailwindcss').Config} */

import tailwindcssPrimeUI from 'tailwindcss-primeui';

// Kept close to homey-admin-app's blue scale (the plain Aura look), but layered
// in via theme.extend.colors so the rest of Tailwind's default palette (red-*,
// green-*, etc.) survives. homey-admin-app's tailwind.config.js fully overrode
// theme.colors with only this scale, which silently broke every red-*/green-*
// utility class in its templates - do not repeat that here.
const blue = {
  50: '#eff6ff',
  100: '#dbeafe',
  200: '#bfdbfe',
  300: '#93c5fd',
  400: '#60a5fa',
  500: '#376ef7',
  600: '#2563eb',
  700: '#1d4ed8',
  800: '#1e40af',
  900: '#1e3a8a',
  950: '#172554',
} as const;

export const colors = {
  blue,
} as const;

const config = {
  content: ['./src/**/*.{html,ts}'],
  theme: {
    extend: {
      colors,
    },
  },
  darkMode: false,
  plugins: [tailwindcssPrimeUI],
};

export default config;
